export default "__VITE_ASSET__DGmbYr8o__"